module.exports = __webpack_public_path__ + "static/media/upcoming-img.6549979d.png";